import { createAppAsyncThunk } from "domain/store.thunk";

export const getCarouselSlides = createAppAsyncThunk(
  "seances/getSeances",
  async (_, { extra: { carouselGateway } }) => {
    return await carouselGateway.getCarouselSlides();
  }
);
